import React, { Component } from 'react';
import moment from 'moment/moment';
import { Timeline } from 'primereact/timeline';
import { Divider } from 'primereact/divider';
import { Tag } from 'primereact/tag';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Button } from 'primereact/button';
import { UtilService } from 'hay-core-react';

// Um marcador/cor por tipoevento - cobre todos os valores do enum (inclusive os reservados pra
// uso futuro, aniversario/fidelizacao) pra nunca cair no marcador padrao à toa.
const EVENTO_CONFIG = {
    'main.usuarioevento.tipoevento.conexao':                { icone: 'pi-wifi',                cor: 'bg-green-500' },
    'main.usuarioevento.tipoevento.desconexao':              { icone: 'pi-sign-out',            cor: 'bg-red-400' },
    'main.usuarioevento.tipoevento.registro':                { icone: 'pi-user-plus',           cor: 'bg-blue-500' },
    'main.usuarioevento.tipoevento.voucher':                 { icone: 'pi-ticket',              cor: 'bg-purple-500' },
    'main.usuarioevento.tipoevento.login':                   { icone: 'pi-sign-in',             cor: 'bg-cyan-500' },
    'main.usuarioevento.tipoevento.aniversario':             { icone: 'pi-gift',                cor: 'bg-pink-500' },
    'main.usuarioevento.tipoevento.pesquisaenviada':         { icone: 'pi-send',                cor: 'bg-orange-500' },
    'main.usuarioevento.tipoevento.pesquisarespondida':      { icone: 'pi-star-fill',           cor: 'bg-yellow-500' },
    'main.usuarioevento.tipoevento.pagamento':               { icone: 'pi-wallet',              cor: 'bg-teal-500' },
    'main.usuarioevento.tipoevento.fidelizacao':             { icone: 'pi-heart-fill',          cor: 'bg-red-500' },
    'main.usuarioevento.tipoevento.limitenavegacaoatingido': { icone: 'pi-exclamation-triangle', cor: 'bg-orange-600' },
    'main.usuarioevento.tipoevento.recuperacaosenha':        { icone: 'pi-key',                 cor: 'bg-bluegray-500' },
};
const EVENTO_CONFIG_PADRAO = { icone: 'pi-circle', cor: 'bg-gray-400' };

// Mesmo agrupamento Hoje/Ontem/Anteriores de DashboardTimeline.js, so trocando datalog por
// createdAt (UsuarioEvento nao tem timestamp proprio - ver comentario no model).
function agruparPorDia(itens) {
    const hoje = moment().startOf('day');
    const ontem = moment().subtract(1, 'day').startOf('day');
    const grupos = { hoje: [], ontem: [], anteriores: [] };

    itens.forEach((item) => {
        const dia = moment(item.createdAt).startOf('day');
        if (dia.isSame(hoje)) {
            grupos.hoje.push(item);
        } else if (dia.isSame(ontem)) {
            grupos.ontem.push(item);
        } else {
            grupos.anteriores.push(item);
        }
    });

    return grupos;
}

// Componente de apresentacao puro (mesmo espirito de DashboardTimeline.js) - toda a riqueza do
// texto (RB/mac/ip na conexao, nota na resposta de pesquisa etc.) ja vem pronta em
// item.descricao, montada no backend no momento em que cada evento e' criado; aqui so cuida do
// agrupamento por dia e do estilo marcador/Tag por tipoevento.
class UsuarioEventoTimeline extends Component {
    marker(item) {
        const cfg = EVENTO_CONFIG[item.tipoevento] || EVENTO_CONFIG_PADRAO;
        return (
            <span className={`flex align-items-center justify-content-center border-circle ${cfg.cor} text-white flex-shrink-0`} style={{ width: '2rem', height: '2rem' }}>
                <i className={`pi ${cfg.icone}`} />
            </span>
        );
    }

    content(item) {
        const t = (chave) => UtilService.traduzir(chave);
        // Nome do usuário sempre à frente do evento - não só quando aberto sem um usuário
        // selecionado (Estado 1/2 do RelatedEntityGrid, ver especificação), pra manter o mesmo
        // texto em qualquer contexto de acesso a esta timeline.
        const nomeUsuario = item.usuario?.nome || item.usuario?.id;
        return (
            <div className="pb-3">
                <div className="flex align-items-start gap-2 flex-wrap">
                    <span>{nomeUsuario && <b>{nomeUsuario} — </b>}{item.descricao || t(item.tipoevento)}</span>
                    <Tag severity="secondary" value={t(item.tipoevento)} />
                </div>
                <div className="text-color-secondary text-sm">{moment(item.createdAt).format('DD/MM/YYYY HH:mm')}</div>
            </div>
        );
    }

    renderGrupo(titulo, itens) {
        if (!itens.length) return null;
        return (
            <div key={titulo} className="mb-3">
                <Divider align="left" type="solid">
                    <b>{titulo}</b>
                </Divider>
                <Timeline
                    value={itens}
                    align="left"
                    marker={(item) => this.marker(item)}
                    content={(item) => this.content(item)}
                    pt={{ opposite: { style: { display: 'none' } } }}
                />
            </div>
        );
    }

    render() {
        const { itens, carregando, temMais, onCarregarMais } = this.props;
        const t = (chave) => UtilService.traduzir(chave);

        if (carregando && !itens?.length) {
            return <div className="surface-card border-round flex justify-content-center p-5"><ProgressSpinner /></div>;
        }
        if (!itens || itens.length === 0) {
            return <div className="surface-card border-round text-color-secondary text-center p-4">{t('main.usuarioevento.timeline.semdados')}</div>;
        }

        const grupos = agruparPorDia(itens);

        return (
            <div className="surface-card border-round p-3">
                {this.renderGrupo(t('main.usuarioevento.timeline.hoje'), grupos.hoje)}
                {this.renderGrupo(t('main.usuarioevento.timeline.ontem'), grupos.ontem)}
                {this.renderGrupo(t('main.usuarioevento.timeline.anteriores'), grupos.anteriores)}
                {temMais && (
                    <div className="flex justify-content-center mt-3">
                        <Button
                            label={t('main.usuarioevento.timeline.carregarmais')}
                            icon="pi pi-refresh"
                            text
                            loading={carregando}
                            onClick={onCarregarMais}
                        />
                    </div>
                )}
            </div>
        );
    }
}

export default UsuarioEventoTimeline;
